'use client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { useState } from 'react'

export default function QueryProvider({ children }) {
    // Create a QueryClient instance using useState to ensure it's stable across re-renders
    // This is the TanStack Query equivalent of SWRConfig
    const [queryClient] = useState(() => new QueryClient({
        defaultOptions: {
            queries: {
                // staleTime: How long data is considered fresh (0 means always stale)
                // This replaces SWR's revalidateOnFocus behavior
                staleTime: 0,
                
                // gcTime (formerly cacheTime): How long inactive data stays in cache
                // This is similar to SWR's internal caching mechanism
                gcTime: 5 * 60 * 1000, // 5 minutes
                
                // refetchOnWindowFocus: Equivalent to SWR's revalidateOnFocus
                refetchOnWindowFocus: false,
                
                // refetchOnReconnect: Equivalent to SWR's revalidateOnReconnect
                refetchOnReconnect: true,
                
                // retry: Number of retry attempts (similar to SWR's errorRetryCount)
                retry: 3,
                
                // retryDelay: Function to determine retry delay
                // This replaces SWR's errorRetryInterval and onErrorRetry logic
                retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
                
                // refetchInterval: Auto-refetch interval (similar to SWR's refreshInterval)
                refetchInterval: false, // Disabled by default, set per query
            },
            mutations: {
                // retry: Number of retry attempts for mutations
                retry: 1,
            },
        },
    }))

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            {/* ReactQueryDevtools provides debugging tools (only in development) */}
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    )
} 